"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NpcWindow;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _NpcWindowModule = _interopRequireDefault(require("./NpcWindow.module.scss"));

var _WindowControls = _interopRequireDefault(require("../../WindowControls/WindowControls"));

var _Button = _interopRequireDefault(require("../../../inputElements/Button/Button"));

var _EButtonType = _interopRequireDefault(require("../../../inputElements/Button/EButtonType"));

var _NpcWindow = _interopRequireDefault(require("./NpcWindow.i18n"));

var _Item = _interopRequireDefault(require("../../../entities/Item/Item"));

var _item = _interopRequireDefault(require("../../../../mocks/item"));

var _Money = _interopRequireDefault(require("../../../common/Money/Money"));

var _moneyToMoneyDivided = _interopRequireDefault(require("../../../../helpers/money/moneyToMoneyDivided"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/jsx-curly-brace-presence */
// TODO: make text (ReactNode) dynamic via props
function NpcWindow(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_NpcWindowModule.default.window, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement(_WindowControls.default, {
    classNameDragHandler: _NpcWindowModule.default.dragHandler,
    classNameCloseBtn: _NpcWindowModule.default.closeBtn
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _NpcWindowModule.default.textBox
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _NpcWindowModule.default.objective
  }, "Albus Dumbledore"), /*#__PURE__*/_react.default.createElement("div", {
    className: _NpcWindowModule.default.npcName
  }, "Justin Bieber"), /*#__PURE__*/_react.default.createElement("p", null, "Hello tranger, my name is Justin Bieber and im the professional singer in this town."), /*#__PURE__*/_react.default.createElement("p", null, "Would you like to hear a sample? You can buy my new album here at my store..."), /*#__PURE__*/_react.default.createElement("p", null, "However, do you think you can do me a favor? ", "I'm", " in troubles with some guys not liking the music I make... which I can not understand because my music is sowhat perfect."), /*#__PURE__*/_react.default.createElement("p", null, "Can you please go and kill their leader, called ", /*#__PURE__*/_react.default.createElement("strong", null, "Albus Dumbledore"), "?. I would really appreciate it and will give you a free exemplar of my new album as reward. What do you think?"), /*#__PURE__*/_react.default.createElement("div", {
    className: _NpcWindowModule.default.rewardsLabel
  }, "REWARD"), /*#__PURE__*/_react.default.createElement("div", {
    className: _NpcWindowModule.default.rewards
  }, /*#__PURE__*/_react.default.createElement("p", null, "EXP: 112"), /*#__PURE__*/_react.default.createElement("p", null, "Money: ", /*#__PURE__*/_react.default.createElement(_Money.default, {
    moneyDivide: (0, _moneyToMoneyDivided.default)(10),
    showNullValues: true
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: _NpcWindowModule.default.itemRewardsLabel
  }, "SELECTION ITEM"), /*#__PURE__*/_react.default.createElement("div", {
    className: _NpcWindowModule.default.itemRewards
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Item.default, {
    item: _item.default
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Item.default, {
    item: _item.default
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Item.default, {
    item: _item.default
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: _NpcWindowModule.default.optionBox
  }, /*#__PURE__*/_react.default.createElement("a", null, "Trade"), /*#__PURE__*/_react.default.createElement("a", null, "Buy his album for 100 PP"), /*#__PURE__*/_react.default.createElement("a", null, "Accept to help with his problem"), /*#__PURE__*/_react.default.createElement("a", null, "Just go by and ignore this guy"), /*#__PURE__*/_react.default.createElement("a", null, "Punch his face and tell him to STFU")), /*#__PURE__*/_react.default.createElement("div", {
    className: _NpcWindowModule.default.footerBtn
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: _EButtonType.default.QUEST_COMMUNITY_NPC
  }, formatMessage(_NpcWindow.default.close))));
}